import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  getSoumission(query_data) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      ...query_data
    };

    return Network.execute('GET', 'CWEBS0045A', data);
  },
  /**
   * Récupère l'historique de la soumission passé en paramètre
   *
   * @param   {integer}  pnsoum  Numéro de la soumission
   *
   * @return  {Pormise}
   */
  getSubmissionHistory(pnsoum) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnsoum
    };

    return Network.execute('GET', 'CWEBS0048A', data);
  },
  getStatus() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
    };

    return Network.execute('GET', 'CWEBS0046A', data);
  },
  /**
   * Envoi une soumission
   *
   * @param   {object}  object  Objet contenant les infos de la soumission
   *
   * @return  {Promise}
   */
  sendSubmission(object) {
   
    let post_data = {
      ds_i: {
        OUT: [object]  
      } 
    };
    
    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
    }

    return Network.execute('POST', 'CWEBS0047A', data, post_data, {
      'content-type': 'application/json'
    });  
  },

  /**
   * [description]
   */
  getResearchStatus() {

    let data = {
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      piduser: Store.getters['application/get_application_user'].id 
    };

    return Network.execute('GET', 'CWEBS0084A', data);
  },
}